
import react, { useState } from "react";
import styles from "./Tabs.module.css";
import HomeClean from "../assets/icon/HomeClean.png"
import Washing from "../assets/icon/washing.png"
import Beauty from "../assets/icon/beauty.png"
import Install from "../assets/icon/installation.png"
import Bath from "../assets/icon/bathroom.png"
import { Link, useNavigate, useNavigation } from "react-router-dom";

const Tabs = () => {
     const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();

  const tabs = ["Home Services", "Contact Services"];

  const content = [
    {
      title: "Home Services",
      categories: [
        {
          parent: "Home Cleaning",
          img: HomeClean,
          subcategories: [
            {
              title: "Full Home Cleaning",
              img: HomeClean,
              navigate: "home/full-clean",
              services: [
                {
                  name: "1 BHK Full Cleaning",
                  img: HomeClean,
                  price: 799,
                },
                {
                  name: "2 BHK Full Cleaning",
                  img: HomeClean,
                  price: 999,
                },
                {
                  name: "3 BHK Deep Cleaning",
                  img: HomeClean,
                  price: 1499,
                },
              ],
            },
            {
              title: "Bathroom Cleaning",
              img: Bath,
              navigate: "home/bathroom-clean",
              services: [
                {
                  name: "1 Bathroom Cleaning",
                  img: Bath,
                  price: 299,
                },
                {
                  name: "2 Bathroom Cleaning",
                  img: Bath,
                  price: 499,
                },
                {
                  name: "Super / Deep Bathroom Cleaning",
                  img: Bath,
                  price: 699,
                },
              ],
            },
            {
              title: "Kitchen Cleaning",
              img: Bath,
              navigate: "home/kitchen-clean",
              services: [
                {
                  name: "Basic Kitchen Cleaning",
                  img: Bath,
                  price: 499,
                },
                {
                  name: "Deep Kitchen Cleaning",
                  img: Bath,
                  price: 799,
                },
              ],
            },
            {
              title: "Sofa & Carpet Cleaning",
              img: Bath,
              navigate: "home/sofa-carpet",
              services: [
                {
                  name: "Sofa Cleaning",
                  img: Bath,
                  price: 299,
                },
                {
                  name: "Carpet Cleaning",
                  img: Bath,
                  price: 399,
                },
              ],
            },
          ],
        },
        {
          parent: "Appliance Services",
          img: Washing,
          subcategories: [
            {
              title: "AC Repair & Service",
              img: Washing,
              navigate: "appliance/ac-repair",
              services: [
                {
                  name: "AC Servicing",
                  img: Washing,
                  price: 499,
                },
                {
                  name: "AC Installation",
                  img: Washing,
                  price: 799,
                },
                {
                  name: "AC Uninstallation",
                  img: Washing,
                  price: 399,
                },
              ],
            },
            {
              title: "Washing Machine Repair",
              img: Washing,
              navigate: "appliance/washing-machine",
              services: [
                {
                  name: "Front Load Service",
                  img: Washing,
                  price: 599,
                },
                {
                  name: "Top Load Service",
                  img: Washing,
                  price: 499,
                },
              ],
            },
            {
              title: "Refrigerator Repair",
              img: Install,
              navigate: "appliance/fridge-repair",
              services: [
                {
                  name: "Single Door",
                  img: Install,
                  price: 499,
                },
                {
                  name: "Double Door",
                  img: Install,
                  price: 699,
                },
              ],
            },
          ],
        },
        {
          parent: "Installation & Repairs",
          img: Install,
          subcategories: [
            {
              title: "Plumbing",
              img: Bath,
              navigate: "install/plumbing",
              services: [
                {
                  name: "Tap Installation",
                  img: Bath,
                  price: 199,
                },
                {
                  name: "Water Leak Fix",
                  img: Bath,
                  price: 299,
                },
              ],
            },
            {
              title: "Electrical Work",
              img: Install,
              navigate: "install/electrical",
              services: [
                {
                  name: "Fan Repair",
                  img: Install,
                  price: 249,
                },
                {
                  name: "Switchboard Repair",
                  img: Install,
                  price: 199,
                },
              ],
            },
          ],
        },
        {
          parent: "Home Maintenance",
          img: Bath,
          subcategories: [
            {
              title: "Pest Control",
              img: Bath,
              navigate: "maintenance/pest-control",
              services: [
                {
                  name: "Cockroach Control",
                  img: Bath,
                  price: 399,
                },
                {
                  name: "Termite Treatment",
                  img: Bath,
                  price: 699,
                },
              ],
            },
            {
              title: "Painting",
              img: Bath,
              navigate: "maintenance/painting",
              services: [
                {
                  name: "1 Room Painting",
                  img: Bath,
                  price: 799,
                },
                {
                  name: "Full Home Painting",
                  img: Bath,
                  price: 1999,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      title: "Contact Services",
      categories: [
        {
          parent: "Electronics",
          img: Bath,
          subcategories: [
            {
              title: "Mobile Repair",
              img: Bath,
              navigate: "contact/mobile",
              services: [
                { name: "Screen Replacement", img: Bath, price: 899 },
                { name: "Battery Replacement", img: Bath, price: 499 },
              ],
            },
            {
              title: "Laptop Repair",
              img: Bath,
              navigate: "contact/laptop",
              services: [
                { name: "OS Installation", img: Bath, price: 799 },
                { name: "Screen Replacement", img: Bath, price: 1299 },
              ],
            },
            {
              title: "Camera Repair",
              img: Bath,
              navigate: "contact/camera",
              services: [
                { name: "Lens Fix", img: Bath, price: 899 },
                { name: "Sensor Cleaning", img: Bath, price: 499 },
              ],
            },
            {
              title: "Smart Watch Repair",
              img: Bath,
              navigate: "contact/watch",
              services: [
                { name: "Battery Replacement", img: Bath, price: 399 },
                { name: "Screen Change", img: Bath, price: 699 },
              ],
            },
          ],
        },
      ],
    },
  ];
  return (
    <div className={styles.container}>
      {/* Tabs Navigation */}
      <div className={styles.tabHeaders}>
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={activeTab === index ? styles.active : ""}
            onClick={() => setActiveTab(index)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Dynamic Tab Content */}
      <div className={styles.tabContent}>
      
     
        <div className={styles.itemsContainer}>
          {content[activeTab].categories.map((item, idx) => (
            <div key={idx}  className={styles.itemCard} onClick={()=>navigate('/product',{state:{subcategory:item.subcategories}})} >
              <img src={item.img} alt={item.title}  />
              <p>{item.parent}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Tabs;
